<template>
  <modal id="galleryReviewModal">
    <template slot="header">
      <div class="modal-header-content">
        <div class="modal-header-title">
          <h2>Add A Review</h2>
          <small>Complete the form to submit your review</small>
        </div>
        <button type="button" class="modal-header-close" data-dismiss="modal" aria-label="Close" @click.prevent="resetModal">×</button>
      </div>
    </template>

    <div class="alert alert-danger color-error msgblock" v-if="formErrors">
      {{ formErrors }}
    </div>
    <div class="alert alert-danger msgblock" v-show="errors.any()">
      <span v-for="error in errors.all()" :key="error.index">
        {{ error }} <br />
      </span>
    </div>
    <div class="alert alert-success msgblock" v-if="formSuccess">
      {{ formSuccess }}
    </div>

    <form enctype="multipart/form-data">
      <div class="modal-form">
        <fieldset>
          <div class="modal-form-field">
            <label class="modal-form-label">
              <strong>Review Title:</strong>
              <div class="modal-form-input">
                <input type="text" class="form-control" placeholder="Short title for the project/work">
              </div>
            </label>
          </div>
          <div class="modal-form-field">
            <label class="modal-form-label">
              <strong>Email:</strong>
              <div class="modal-form-input">
                <input type="text" name="recipient" class="form-control" placeholder="your-email@example.com"
                  v-model="form.client_email" v-validate="'required'">
                <span v-show="errors.has('recipient')" class="text-danger">{{ errors.first('recipient') }}</span>
              </div>
            </label>
          </div>
          <div class="modal-form-field">
            <label class="modal-form-label">
              <strong>Review Body:</strong>
              <div class="modal-form-input">
                <textarea rows="5" class="form-control" v-model="form.message" placeholder="Brief summary of the project/work">
              </textarea>
              </div>
            </label>
          </div>
        </fieldset>
      </div>
    </form>

    <template slot="footer">
      <div class="modal-footer-actions">
        <button type="button" class="modal-footer-cancel" data-dismiss="modal" aria-label="Close" @click.prevent="resetModal">Cancel</button>
        <button v-on:click.prevent="sendReview" class="modal-footer-save" :disabled="errors.any() || processing">
          Submit
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    project: Object | false
  },
  data() {
    return {
      form: {
        client_email: '',
        message: ''
      },
      processing: false,
      formSuccess: null,
      formErrors: null
    }
  },
  methods: {
    resetModal() {
      this.form.client_email = '';
      this.form.message = '';
      this.formSuccess = null;
      this.formErrors = null;
      this.$nextTick(() => {
        this.$validator.reset();
        this.errors.clear();
      });
    },
    async sendReview() {
      const projectID = this.project.id;
      const domain = this.project.domain;

      try {
        let success = await this.$validator.validateAll();

        if (!success) {
          this.$set(this.formErrors, message, 'Please provide a recipient.');
          return false;
        }

        await axios.post('/api/proxify/domains/' + domain + '/projects/' + projectID + '/review', this.form);
        this.$parent.$emit('review-requested', this.project);
        this.formSuccess = 'Your review request has been sent!';
        this.project.review_requested = true;
        this.resetModal();
        $('#galleryReviewModal').modal('hide');
      } catch (error) {
        this.$root.$refs.notifications.add({
          type: "error",
          icon: "exclamation-triangle",
          title: "Something went wrong",
          message: error.response.data.message ? error.response.data.message : 'Unable to review the selected project. Please contact customer support if you continue having this issue.'
        });
        if (error.length && error.response.status === 400) {
          const status = error.response.status;
          const apiMessage = error.response.data.message;
          if (status === 400 && apiMessage.includes('not currently approved')) {
            this.formErrors = "This project must be approved before a review request can be submitted.";
          } else if (status === 400) {
            this.formErrors = 'This project already has a review.';
          } else {
            this.formErrors = 'An error occurred while trying to send your request.';
          }
        }
      }
    }
  }
}
</script>
